<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="success" @click="exportAllReport()">Export</v-btn>
          <v-menu v-model="filterValue" :close-on-content-click="false">
            <v-btn slot="activator" color="primary"
              >Filter<v-icon>filter_list</v-icon></v-btn
            >
            <v-expand-transition>
              <asset-summary-report-search
                @close="filterValue = false"
                @search="onSearch"
              ></asset-summary-report-search>
            </v-expand-transition>
          </v-menu>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <span class="pt-2">Search By: </span>
              <v-chip color="#3498db" v-if="queryParams.fromMonth">
                <span>From Month: {{ queryParams.fromMonth }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.toMonth">
                <span>To Month: {{ queryParams.toMonth }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.branchId">
                <span>Branch Name: {{ branchName }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.shopId">
                <span>Shop Name: {{ shopName }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.departmentId">
                <span>Department Name: {{ departmentName }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.accountName">
                <span>Account Name: {{ queryParams.accountName }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.assetName">
                <span>Asset Name: {{ queryParams.assetName }}</span>
              </v-chip>
              <v-chip color="#3498db" v-if="queryParams.assetType">
                <span>Asset Type: {{ queryParams.assetType }}</span>
              </v-chip>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="assetSummaryReportList"
          class="elevation-1"
          :loading="showListLoading"
          :total-items="totalRows"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          :must-sort="true"
        >
          <template slot="items" slot-scope="props">
            <td style="text-align: right;">{{ props.item.no }}</td>
            <td>{{ props.item.assetType }}</td>
            <td style="text-align: right;">{{ props.item.originalAmount | decFormat }}</td>
            <td style="text-align: right;">{{ props.item.openingAmount | decFormat }}</td>
            <td style="text-align: right;">{{ props.item.filterMonthAmount | decFormat }}</td>
            <td style="text-align: right;">{{ props.item.closingAmount | decFormat }}</td>
            <td style="text-align: right;">{{ props.item.remainingAmount | decFormat }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { assetSummaryReportService } from "../../services/asset-summary-report-service";
import { commonService } from "../../services/common-service";
import AssetSummaryReportSearch from "./AssetSummaryReportSearch";

export default {
  name: "AssetSummaryReportList",
  components: { AssetSummaryReportSearch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showListLoading: false,
    filterValue: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Asset Summary Report ",
        disabled: true,
      },
    ],
    headers: [
      { text: "No", align: "right", sortable: false },
      { text: "Asset Type", value: "temp.assetType"},
      { text: "Origin Amount", sortable: false, align: "right" },
      { text: "Opening Amount", sortable: false, align: "right" },
      { text: "", sortable: false, align: "right" },
      { text: "Closing Amount", sortable: false, align: "right" },
      { text: "Remining Amount", sortable: false, align: "right" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "temp.assetType",
      totalItems: 0,
    },
    queryParams: {
      fromMonth: new Date().toISOString().substring(0, 7),
      toMonth: new Date().toISOString().substring(0, 7),
      branchId: "",
      shopId: "",
      departmentId: "",
      accountName: "",
      assetName: "",
      assetType: "",
    },
    totalRows: 0,
    branchName: "",
    shopName: "",
    departmentName: "",
    assetSummaryReportList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAssetSummaryReportList();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.roleName == "ASSET_MANAGER") {
      this.queryParams.shopId = this.user.shopId;
      this.queryParams.shopName = this.user.shop.name;
    }
    this.dynamicHeader();
    //for deep linking
    if (this.$route.query.fromMonth) {
      this.queryParams.fromMonth = this.$route.query.fromMonth;
    }
    if (this.$route.query.toMonth) {
      this.queryParams.toMonth = this.$route.query.toMonth;
    }
    if (this.$route.query.branchId) {
      this.queryParams.branchId = this.$route.query.branchId;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = this.$route.query.departmentId;
    }
    if (this.$route.query.assetName) {
      this.queryParams.assetName = this.$route.query.assetName;
    }
    if (this.$route.query.accountName) {
      this.queryParams.accountName = this.$route.query.accountName;
    }
    if (this.$route.query.assetType) {
      this.queryParams.assetType = this.$route.query.assetType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch(searchParams) {
      //close search
      this.filterValue = false;
      //set parameters
      this.queryParams.fromMonth = searchParams.fromMonth;
      this.queryParams.toMonth = searchParams.toMonth;
      this.queryParams.branchId = searchParams.branchId;
      this.queryParams.shopId = searchParams.shopId;
      this.queryParams.departmentId = searchParams.departmentId;
      this.queryParams.accountName = searchParams.accountName;
      this.queryParams.assetName = searchParams.assetName;
      this.queryParams.assetType = searchParams.assetType;
      this.shopName = searchParams.shopName;
      this.departmentName = searchParams.departmentName;
      this.branchName = searchParams.branchName;
      
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      //search
      this.$router.replace({
        name: "asset-summary-report",
        query: this.queryParams,
      });
      this.getAssetSummaryReportList();
      this.dynamicHeader();
    },
    dynamicHeader() {
      const fromDate = new Date(`${this.queryParams.fromMonth}-01`);
      const fromMonthName = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(fromDate);

      const toDate = new Date(`${this.queryParams.toMonth}-01`);
      const toMonthName = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(toDate);

      this.headers.splice(4, 1, {
        text: `${fromMonthName} - ${toMonthName}`,
        align: "right",
        sortable: false,
      });
    },
    getAssetSummaryReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      assetSummaryReportService
        .getAssetSummaryReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.assetSummaryReportList = res.data.assetSummaryReportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllReport() {
      this.buttonLoading = true;
      assetSummaryReportService
        .exportAllAssetSummaryReportExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
